
import React from 'react';
import { Link } from 'react-router-dom';

const SecurityConsiderations: React.FC = () => {
  return (
    <section>
      <h2 className="text-2xl font-bold text-itmgmt-dark-blue mb-6">Security Considerations for Real Estate Technology</h2>
      
      <p className="mb-4 text-gray-700 leading-relaxed">
        Real estate transactions involve significant personal and financial data, making security a critical 
        concern for any technology implementation:
      </p>
      
      <div className="mb-8">
        <h3 className="text-xl font-semibold text-itmgmt-medium-blue mb-4">Essential Security Measures</h3>
        <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
          <li className="leading-relaxed">
            <strong>Data Encryption:</strong> Ensure all systems use strong encryption for data both in transit and at rest, 
            especially for financial information and personally identifiable information (PII).
          </li>
          <li className="leading-relaxed">
            <strong>Multi-Factor Authentication:</strong> Implement MFA for all critical systems to prevent 
            unauthorized access even if passwords are compromised, a cornerstone of <Link to="/blog/zero-trust-security-small-businesses" className="text-itmgmt-bright-blue hover:underline">zero-trust security</Link>.
          </li>
          <li className="leading-relaxed">
            <strong>Role-Based Access Controls:</strong> Limit data access based on job roles and 
            responsibilities to reduce risk exposure.
          </li>
          <li className="leading-relaxed">
            <strong>Regular Security Training:</strong> Educate all staff on security best practices, 
            recognizing phishing attempts, and proper data handling procedures.
          </li>
          <li className="leading-relaxed">
            <strong>Wire Fraud Prevention:</strong> Implement specific protocols to prevent real estate wire fraud, 
            which has become increasingly common.
          </li>
          <li className="leading-relaxed">
            <strong>Secure Client Portals:</strong> Use secure portals rather than email for sharing sensitive documents.
          </li>
          <li className="leading-relaxed">
            <strong>Mobile Device Management:</strong> Deploy MDM solutions to protect data on agent mobile devices 
            and enable remote wiping if devices are lost.
          </li>
        </ul>
      </div>
      
      <p className="mb-4 text-gray-700 leading-relaxed">
        Working with a specialized <Link to="/services/cybersecurity" className="text-itmgmt-bright-blue hover:underline">IT security provider</Link> familiar with real estate industry requirements 
        can help ensure comprehensive protection that meets regulatory standards while maintaining operational efficiency.
        Learn more about implementing <Link to="/blog/cybersecurity-best-practices-small-business" className="text-itmgmt-bright-blue hover:underline">cybersecurity best practices</Link> for your business.
      </p>
    </section>
  );
};

export default SecurityConsiderations;
